import { render, staticRenderFns } from "./RenameDialog.vue?vue&type=template&id=adcbd152&"
import script from "./RenameDialog.vue?vue&type=script&lang=js&"
export * from "./RenameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adcbd152')) {
      api.createRecord('adcbd152', component.options)
    } else {
      api.reload('adcbd152', component.options)
    }
    module.hot.accept("./RenameDialog.vue?vue&type=template&id=adcbd152&", function () {
      api.rerender('adcbd152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Modals/RenameDialog.vue"
export default component.exports